export enum DefectType {
  Quarantine = 'quarantine',
  Tunnel = 'tunnel',
}
